// @flow

export default { onModalShow: (item: string): null => ({ type: 'VISIT_AFTER_BABY_TOPIC', item }) };
